import React from 'react';
import { Instagram, Twitter, Linkedin, Mail } from 'lucide-react';

const items = [
  ['https://instagram.com/sebachuffer', Instagram, 'Instagram'],
  ['https://x.com/sebadelfuturo', Twitter, 'X'],
  ['https://www.linkedin.com/in/sebachuffer', Linkedin, 'LinkedIn'],
  ['mailto:sebachuffer@gmail.com', Mail, 'Email'],
];

const Contact = () => (
  <section id="contacto" className="py-24 md:py-32 text-center px-6">
    <p className="text-[11px] tracking-[0.42em] uppercase text-muted mb-4">Contacto</p>
    <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight mb-8">Conversemos</h2>
    <p className="font-serif text-[17px] text-ink/70 max-w-md mx-auto mb-12">
      Para muestras, colaboraciones o simplemente para hablar de fotografía.
    </p>
    <div className="flex justify-center gap-4 md:gap-5">
      {items.map(([href, Icon, label]) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="w-12 h-12 border border-line rounded-full flex items-center justify-center text-ink hover:bg-ink hover:text-paper transition-colors duration-300"
        >
          <Icon size={18} strokeWidth={1.4} />
        </a>
      ))}
    </div>
  </section>
);

export default Contact;
